import React, { useState } from "react";
import { motion } from "framer-motion";
import { ArrowUpRight, Check } from "lucide-react";
import { toast } from "sonner";

export default function Newsletter() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);

  const submit = (e) => {
    e.preventDefault();
    if (!email || !email.includes("@")) {
      toast.error("Drop a real email to join the crew.");
      return;
    }
    setDone(true);
    toast.success("You're on the roll call. Welcome to detention.");
    setTimeout(() => {
      setName("");
      setEmail("");
      setDone(false);
    }, 2200);
  };

  return (
    <section
      id="newsletter"
      data-testid="newsletter-section"
      className="relative bg-[var(--st-maroon)] text-white py-16 md:py-24 border-b-2 border-[#111] overflow-hidden"
    >
      <div className="absolute inset-0 opacity-10 pointer-events-none grid-paper-fine" />
      <div className="max-w-[1400px] mx-auto px-4 md:px-8 grid grid-cols-12 gap-6 items-center relative">
        <motion.form
          onSubmit={submit}
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="col-span-12 md:col-span-5 flex flex-col gap-3"
        >
          <input
            type="text"
            placeholder="NICKNAME"
            value={name}
            onChange={(e) => setName(e.target.value)}
            data-testid="newsletter-name"
            className="bg-[var(--st-maroon-deep)] border-2 border-[var(--st-gold)] px-4 py-3 font-heading uppercase tracking-[0.18em] text-sm text-white placeholder:text-white/40 focus:outline-none focus:border-[var(--st-mustard)]"
          />
          <input
            type="email"
            placeholder="YOUR EMAIL"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            data-testid="newsletter-email"
            className="bg-[var(--st-maroon-deep)] border-2 border-[var(--st-gold)] px-4 py-3 font-heading uppercase tracking-[0.18em] text-sm text-white placeholder:text-white/40 focus:outline-none focus:border-[var(--st-mustard)]"
          />
          <button
            type="submit"
            data-testid="newsletter-submit"
            className="self-start mt-2 inline-flex items-center gap-2 bg-[var(--st-mustard)] text-[var(--st-fg)] px-5 py-3 border-2 border-[#111] font-heading uppercase tracking-[0.18em] text-sm hover:bg-[var(--st-gold)] transition-colors shadow-brutal-sm"
          >
            {done ? (
              <>
                <Check size={14} /> Joined
              </>
            ) : (
              <>
                Sign Up <ArrowUpRight size={14} />
              </>
            )}
          </button>
        </motion.form>

        <motion.div
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.1 }}
          className="col-span-12 md:col-span-7"
        >
          <h2 className="font-display uppercase leading-[0.85] tracking-tight text-[var(--st-gold)] text-5xl md:text-7xl lg:text-8xl">
            JOIN THE
            <br />
            <span className="text-white">ROLL CALL</span>
          </h2>
          <p className="mt-4 font-body text-base text-white/80 max-w-md">
            Get drop alerts, behind the scenes, and detention-only discounts before anyone else.
          </p>
        </motion.div>
      </div>
    </section>
  );
}
